export const THEME_STORAGE_KEY = "theme-preference"

export const THEME_OPTIONS = {
  SYSTEM: "system",
  LIGHT: "light",
  DARK: "dark",
}

export function isThemeOption(value) {
  return Object.values(THEME_OPTIONS).includes(value)
}

export function getStoredTheme() {
  if (typeof window === "undefined") {
    return THEME_OPTIONS.SYSTEM
  }

  const storedTheme = window.localStorage.getItem(THEME_STORAGE_KEY)
  return isThemeOption(storedTheme) ? storedTheme : THEME_OPTIONS.SYSTEM
}

export function setStoredTheme(theme) {
  if (typeof window === "undefined" || !isThemeOption(theme)) {
    return
  }

  window.localStorage.setItem(THEME_STORAGE_KEY, theme)
}

export function applyTheme(theme) {
  if (typeof document === "undefined") {
    return
  }

  const root = document.documentElement
  const normalizedTheme = isThemeOption(theme) ? theme : THEME_OPTIONS.SYSTEM

  if (normalizedTheme === THEME_OPTIONS.SYSTEM) {
    root.removeAttribute("data-theme")
    return
  }

  root.setAttribute("data-theme", normalizedTheme)
}

